/** Split a run into the two review phases: orchestration (tool calls) and outcome (finish). */

import type { AgentRun, AgentStep, FinishStep, ToolCallStep } from "./types";

export interface RunPhases {
  orchestration: ToolCallStep[];
  orchestrationIndices: number[];
  outcome: FinishStep | null;
  outcomeIndex: number | null;
}

export function splitRunPhases(run: AgentRun): RunPhases {
  const orchestration: ToolCallStep[] = [];
  const orchestrationIndices: number[] = [];
  let outcome: FinishStep | null = null;
  let outcomeIndex: number | null = null;

  run.steps.forEach((step, i) => {
    if (step.action === "tool_call") {
      orchestration.push(step);
      orchestrationIndices.push(i);
    } else {
      outcome = step;
      outcomeIndex = i;
    }
  });

  return { orchestration, orchestrationIndices, outcome, outcomeIndex };
}

export function toolDisplay(run: AgentRun, toolName: string): { friendly: string; description: string } {
  const known = run.available_tools.find((t) => t.name === toolName);
  if (known) return { friendly: known.friendly, description: known.description };
  const friendly = toolName.replace(/[_.]/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  return { friendly, description: "" };
}

export function firstOrchestrationStep(run: AgentRun): { step: ToolCallStep; index: number } | null {
  const idx = run.steps.findIndex((s) => s.action === "tool_call");
  if (idx < 0) return null;
  return { step: run.steps[idx] as ToolCallStep, index: idx };
}

export function finishStep(run: AgentRun): { step: FinishStep; index: number } | null {
  let idx = -1;
  for (let i = run.steps.length - 1; i >= 0; i -= 1) {
    if (run.steps[i].action === "finish") {
      idx = i;
      break;
    }
  }
  if (idx < 0) return null;
  return { step: run.steps[idx] as FinishStep, index: idx };
}
